// src/supplier/supplierRoutes.jsx
import { Routes, Route } from "react-router-dom";
import RequireSupplier from "./components/RequireSupplier";
import SupplierLayout from "./layout/SupplierLayout";
import SupplierDashboard from "./pages/SupplierDashboard";
import SupplierBusinesses from "./pages/SupplierBusinesses";
import SupplierProducts from "./pages/SupplierProducts";
import SupplierRFQs from "./pages/SupplierRFQs";
import SupplierOrders from "./pages/SupplierOrders";
import SupplierDeliveries from "./pages/SupplierDeliveries";
import SupplierSettings from "./pages/SupplierSettings";
import SupplierNotifications from "./pages/SupplierNotifications";

export default function SupplierRoutes() {
  return (
    <Routes>
      <Route element={<RequireSupplier />}>
        <Route element={<SupplierLayout />}>
          <Route index element={<SupplierDashboard />} />
          <Route path="businesses" element={<SupplierBusinesses />} />
          <Route path="businesses/:businessId" element={<SupplierBusinesses />} />
          <Route path="products" element={<SupplierProducts />} />
          <Route path="rfqs" element={<SupplierRFQs />} />
          <Route path="orders" element={<SupplierOrders />} />
          <Route path="deliveries" element={<SupplierDeliveries />} />
          <Route path="notifications" element={<SupplierNotifications />} />
          <Route path="settings" element={<SupplierSettings />} />
        </Route>
      </Route>
    </Routes>
  );
}
